<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://tojtel.tj"
        target="_blank"
      >Toj-Tel</b-link>
      <span class="d-none d-sm-inline-block">, Все права защищены.</span>
    </span>

    <span class="float-md-right d-none d-md-block">Разработка:  <a target="_blank" href="https://azizon.cc">Azizon CC</a>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
